// ── ReportSellerModal.jsx ─────────────────────────────────────────────────────
// Sub-modal: report a seller with reason selection and optional details

import React from 'react';
import styles from '../ProductDetailModal.module.css';

const REPORT_REASONS = [
  { value: 'spam',          label: 'Spam or Misleading'      },
  { value: 'scam',          label: 'Suspected Scam'           },
  { value: 'fake',          label: 'Fake or Counterfeit Product' },
  { value: 'inappropriate', label: 'Inappropriate Content'    },
  { value: 'harassment',    label: 'Harassment or Abuse'      },
  { value: 'stolen',        label: 'Stolen Goods'             },
  { value: 'prohibited',    label: 'Prohibited Items'         },
  { value: 'other',         label: 'Other'                    },
];

const ReportSellerModal = ({
  product,
  reportReason,
  setReportReason,
  reportDetails,
  setReportDetails,
  reportSuccess,
  reportError,
  setReportError,
  isSubmittingReport,
  onSubmit,
  onClose,
}) => {
  return (
    <div
      className={styles.offerModalOverlay}
      onClick={() => !isSubmittingReport && onClose()}
    >
      <div className={styles.offerModal} onClick={(e) => e.stopPropagation()}>
        <button
          className={styles.offerCloseBtn}
          onClick={onClose}
          disabled={isSubmittingReport}
        >
          ×
        </button>

        <h3>🚩 Report this Seller</h3>
        <p className={styles.offerModalSubtitle}>
          Seller: <strong>{product.seller}</strong>
        </p>

        {reportSuccess && (
          <div className={styles.successBanner}>✅ {reportSuccess}</div>
        )}
        {reportError && (
          <div className={styles.errorBanner}>❌ {reportError}</div>
        )}

        {/* Reason dropdown */}
        <div className={styles.offerInputGroup}>
          <label>Reason for Reporting *</label>
          <select
            className={styles.offerInput}
            value={reportReason}
            onChange={(e) => {
              setReportReason(e.target.value);
              if (reportError) setReportError('');
            }}
            disabled={isSubmittingReport}
          >
            <option value="">-- Select a reason --</option>
            {REPORT_REASONS.map(({ value, label }) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </select>
        </div>

        {/* Additional details */}
        <div className={styles.offerInputGroup}>
          <label>Additional Details (Optional)</label>
          <textarea
            className={styles.offerTextarea}
            placeholder="Please provide more information to help us review this report..."
            value={reportDetails}
            onChange={(e) => setReportDetails(e.target.value)}
            rows="4"
            maxLength="500"
            disabled={isSubmittingReport}
          />
          <small style={{ color: '#9ca3af', fontSize: '11px' }}>
            {reportDetails.length}/500 characters
          </small>
        </div>

        {/* Warning notice */}
        <div style={{
          background: '#FEF3C7',
          border: '1px solid #FCD34D',
          borderRadius: '6px',
          padding: '10px 12px',
          marginTop: '12px',
          fontSize: '12px',
          color: '#92400E',
        }}>
          <strong>⚠️ Note:</strong> False reports may result in action against your account.
          All reports are reviewed by our team.
        </div>

        {/* Action buttons */}
        <div className={styles.offerModalButtons}>
          <button
            className={styles.offerSubmitBtn}
            onClick={onSubmit}
            disabled={isSubmittingReport || !reportReason}
            style={{
              background: !reportReason ? '#9ca3af' : '#dc2626',
              cursor: !reportReason ? 'not-allowed' : 'pointer',
            }}
          >
            {isSubmittingReport ? 'Submitting Report...' : 'Submit Report'}
          </button>
          <button
            className={styles.offerCancelBtn}
            onClick={onClose}
            disabled={isSubmittingReport}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportSellerModal;
